import ReportAuthorButton from "components/ReportDropdown/ReportAuthorButton";
import Heading from "hardcover-ui/components/Heading";
import Avatar from "hardcover-ui/components/Avatar";
import ExpandingText from "components/ui/ExpandingText";
import Icon from "hardcover-ui/components/Icon";
import faExternalLink from "icons/regular/link.svg";
import TextLink from "hardcover-ui/components/TextLink";
import { PageSerializersAuthorsLayout } from "types/serializers";
import AuthorBio from "./AuthorBio";

export default function AuthorHeader({ author }: { author: PageSerializersAuthorsLayout }) {
  return (
    <>
      <div className="flex flex-row space-x-4">
        <div className="flex-none space-y-4 flex items-end flex-col">
          <Avatar image={author.image} size="xl" alt={author.name} />
          <ReportAuthorButton author={author} />
        </div>
        <div>
          <Heading>{author.name}</Heading>
          <AuthorBio author={author} />
        </div>
      </div>

      <div className="mb-4">
        {author.bio?.length > 0 && (
          <div className="my-4">
            <Heading level={2} size="md">
              Author Bio
            </Heading>
            <ExpandingText text={author.bio} lines={6} />
          </div>
        )}

        {author.links.length > 0 && (
          <p>
            <TextLink
              href={author.links[0].url}
              target="_blank"
              rel="noreferrer"
              underline
            >
              <span>{author.links[0].title}</span>
              <Icon
                icon={faExternalLink}
                size="xs"
                className="fill-gray-400 dark:fill-gray-200 ml-2"
              />
            </TextLink>
          </p>
        )}
      </div>
    </>
  );
}